import React from 'react';
import { i18n } from 'utils/i18n';
import { sanitize } from 'utils/validation';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants/modals';
import { ModalFooterWithRouter as ModalFooter } from 'components/Modal/ModalFooter';

const RecommendedExtraDetailsModal = ({ recommendedDetailLabel, recommendedDetailedDescription }) => (
  <Modal modalKey={MODAL.RECOMMENDED_EXTRA_DETAILS_MODAL} header={recommendedDetailLabel} theme={MODAL_THEMES.WHITE}>
    <>
      <div dangerouslySetInnerHTML={sanitize(recommendedDetailedDescription)} />
      <ModalFooter
        buttons={[
          {
            type: MODAL_BUTTON_TYPES.ACCEPT,
            label: i18n('common_close'),
            analyticsValue: i18n('common_close'),
          },
        ]}
      />
    </>
  </Modal>
);

export default RecommendedExtraDetailsModal;
